const USAGE_LIMIT_PATTERNS = [
    /\busage\s+limit\b/i,
    /\bbilling\s+cycle\b/i,
    /\binsufficient[_\s-]*quota\b/i,
    /\bquota\s+(?:exceeded|exhausted|used\s+up|limit)\b/i,
    /\bquota\b/i,
    /\brate[_\s-]*limit(?:ed|ing)?\b/i,
    /\bratelimit(?:error|exceeded)?\b/i,
    /\b(?:http|status|status\s+code|response|error|code)[^\n\r]{0,40}\b429\b/i,
    /\b429\b[^\n\r]{0,40}\b(?:too\s+many\s+requests|rate[_\s-]*limit|quota|usage\s+limit)\b/i,
    /额度(?:不足|耗尽|用尽|已用尽|限制|已达|达到|上限)/,
    /配额(?:不足|耗尽|用尽|已用尽|限制|已达|达到|上限)/,
    /用量(?:限额|限制|耗尽|用尽|已达)/,
    /账期.*(?:额度|配额|用量)/,
    /达到(?:模型)?(?:额度|配额)上限/,
];

export function isUsageLimitIssue(reason) {
    if (!reason) return false;
    const text = String(reason);
    return USAGE_LIMIT_PATTERNS.some((pattern) => pattern.test(text));
}

export function getProcessingIssueDisplay(reason) {
    if (!reason) return null;

    const rawReason = String(reason);
    if (isUsageLimitIssue(rawReason)) {
        return {
            type: "usage_limit",
            label: "模型额度不足",
            tooltip: `模型额度不足（Usage Limit）\n\n原始错误摘要：${rawReason}`,
        };
    }

    return {
        type: "generic",
        label: rawReason,
        tooltip: rawReason,
    };
}
